import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import {useSelfInfo} from '../../hooks/users';
import {fetchAdviseSessions} from '../../providers/core/adviseSessions';

const useStyles = makeStyles((theme) => ({
  content: {
    borderRadius: 8,
    padding: 4,
    backgroundColor: '#5eab3f',
    margin: 4,
    width: '100%',
  },

  textStyle: {
    color: '#fff',
    fontSize: 17,
  },
}));

let observer1,
  observer2,
  observer3,
  showLayout = false,
  fetchAdviserSession = true,
  adviseId;

function Layout() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Grid container justify="center" alignItems="center">
      <div
        className={classes.content}
        onClick={() => {
          history.push(`/app/advise-sessions/${adviseId}`);
        }}
      >
        <Grid container justify="center">
          <text className={classes.textStyle}>ورود به جلسه مشاوره</text>
        </Grid>
      </div>
    </Grid>
  );
}

export function showSignboard(adviseSessionId, show) {
  if (show) {
    adviseId = adviseSessionId;
    showLayout = true;
  } else if (adviseId === adviseSessionId) {
    showLayout = false;
  } else {
    return;
  }

  if (observer1) {
    observer1(showLayout);
  }

  if (observer2) {
    observer2(showLayout);
  }

  if (observer3) {
    observer3(showLayout);
  }
}

export function hideSignboard() {
  if (observer1) {
    observer1(false);
  }

  if (observer2) {
    observer2(false);
  }

  if (observer3) {
    observer3(false);
  }
}

export function Signboard1() {
  const [show, setShow] = useState(showLayout);
  const {selfInfo} = useSelfInfo();

  if (selfInfo) {
    try {
      if (fetchAdviserSession) {
        fetchAdviserSession = false;
        fetchAdviseSessions({
          offset: 0,
          limit: 5,
          requisitionType:
            selfInfo.userType === 'ADVISER' ? 'INCOMING' : 'OUTGOING',
        });
      }
    } catch (e) {}
  }

  observer1 = setShow;
  return show ? <Layout /> : null;
}

export function Signboard2() {
  const [show, setShow] = useState(showLayout);
  observer2 = setShow;
  return show ? <Layout /> : null;
}

export function Signboard3() {
  const [show, setShow] = useState(showLayout);

  observer3 = setShow;
  return show ? <Layout /> : null;
}
